import { getProductWithMeasurementsDev } from './getProductWithMeasurementsDev';
import { getProductWithMeasurementsLive } from './getProductWithMeasurementsLive';

const isDev = process.env.NODE_ENV === 'development';

export const getProductWithMeasurements = isDev
  ? getProductWithMeasurementsDev
  : getProductWithMeasurementsLive;

// export const getProductWithMeasurements = getProductWithMeasurementsDev;
